import { render } from "./three-dots.vue?vue&type=template&id=65e58afa"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/three-dots.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65e58afa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65e58afa', __exports__)) {
    api.reload('65e58afa', __exports__)
  }
  
  module.hot.accept("./three-dots.vue?vue&type=template&id=65e58afa", () => {
    api.rerender('65e58afa', render)
  })

}


export default __exports__